import React, { FC } from 'react';

import { WarningAlt } from '@yandex-360/iconostasis/dist/icons/WarningAlt';
import { Text } from '@yandex-360/orb-components/dist/components/Text';
import { useSelector } from 'react-redux';

import { selectMicrophoneDevicePermission } from '../../../../../../../../../pages/call/features/device/selectors';
import { i18n } from '../../../../../../../../helpers/i18n';
import { getAudioInputError } from '../../../../../../../device-manager/selectors';
import { DEVICE_DENIED_ERRORS } from '../../../../../../constants';
import { Heading } from '../../../../heading';
import css from '../styles.css';
import { InputDeviceLeveL } from './input-device-level';

export const InputDeviceHeader: FC = () => {
    const isInputAudioDeviceError = useSelector(getAudioInputError);
    const devicePermissionState = useSelector(selectMicrophoneDevicePermission);
    const isDevicePermissionError =
        (isInputAudioDeviceError && DEVICE_DENIED_ERRORS.has(isInputAudioDeviceError)) ||
        devicePermissionState === 'denied';

    return (
        <div className={css.headingWrapper}>
            <Heading
                title={i18n('settings-v2', 'sound-microphone')}
                rightCustom={
                    isDevicePermissionError ? (
                        <div className={css.noAccessWrapper}>
                            <WarningAlt size="sm" variant="outline" className={css.noAccessIcon} />
                            <Text typography="body-md-regular">
                                {i18n('settings-v2', 'diagnostic-device-permission-denied')}
                            </Text>
                        </div>
                    ) : (
                        <InputDeviceLeveL />
                    )
                }
            />
        </div>
    );
};
